import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Link, Typography } from '@mui/material';

import { openDialogAction } from 'store/global/actions';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';
import useDisclosureDelivery from '../../hooks/useDisclosureDelivery';
import DisclosureAuditTrailDialog from '../DisclosureAuditTrailDialog';

import { rowStyles, segmentStyles } from './DisclosureAuditStrip.styles';

const DisclosureAuditStrip = () => {
  const dispatch = useDispatch();
  const { hostConfig, issuedBy, actorDirectory, auditEntries, isAuditUnavailable } =
    useDisclosureDelivery();

  const hasAuditTrail = !isAuditUnavailable && (auditEntries?.length ?? 0) > 0;

  const onViewAuditTrail = useCallback(() => {
    dispatch(
      openDialogAction({
        header: 'Disclosure audit trail',
        body: () => (
          <DisclosureAuditTrailDialog directory={actorDirectory} entries={auditEntries} />
        ),
      }),
    );
  }, [dispatch, actorDirectory, auditEntries]);

  if (!hostConfig.showAuditStrip || (!issuedBy && !hasAuditTrail)) {
    return null;
  }

  return (
    <Box data-testid={DisclosureDeliveryTestIds.AUDIT_STRIP} sx={rowStyles}>
      {!!issuedBy && (
        <Box sx={segmentStyles}>
          <Typography color="text.secondary" variant="regular12">
            Issued by
          </Typography>
          <Typography variant="medium12">{issuedBy}</Typography>
        </Box>
      )}
      {hasAuditTrail && (
        <Link
          component="button"
          data-testid={DisclosureDeliveryTestIds.VIEW_AUDIT_TRAIL_BUTTON}
          type="button"
          underline="hover"
          variant="medium12"
          onClick={onViewAuditTrail}
        >
          View audit trail
        </Link>
      )}
    </Box>
  );
};

export default DisclosureAuditStrip;
